<template>
<center>
    <card class="card card-body agatrs-card-style">
        <Header pageTitle="Manage Operation / Theater" class="card-container"></Header>
        <div class="col-md-12">
            <div class="row">
                <export-group class="col-md-4" :name="'Theaters'" :excelUrl="`api/theaters/excel`" :getData="getExportData"></export-group>

                <div class="col-md-5 col-sm-6 col-xs-6 align-right">
                    <base-button @click="openModal()" class="btn-dark float-sm-none more-margin-top float-md-left">
                        <i class="tim-icons icon-simple-add center-btn-content"></i> Add Operation / Theater
                    </base-button>
                </div>

                <div class="col-md-3">
                    <label for="searchBox">Search:</label>
                    <el-input id="searchBox" type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search" v-model="searchQuery" placeholder="Search all Operation / Theater..." v-b-popover.hover.bottom="
                'Search results appear immediately upon typing.'
              "></el-input>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <el-table :data="queriedData" empty-text="No Operation / Theaters found" role="table"
        aria-label="Operation / Theater Table">
                <el-table-column :min-width="250" label="Actions">
                    <template slot-scope="{ row }">
                        <el-tooltip content="Edit this Operation / Theater." :open-delay="300" effect="light" placement="top">
                            
                                <span @click="editOperationTheater(row)" class="btn-link btn-primary"> <i class="tim-icons icon-pencil"></i> Edit </span>
                            
                        </el-tooltip>
                        <el-tooltip content="Delete this Operation / Theater." :open-delay="300" effect="light" placement="top">
                            <a href="##" @click.stop.prevent="handleDelete(row)" class="btn-link btn-danger">
                                <i class="tim-icons icon-trash-simple"></i>
                                <span class="hide-if-small-screensize"> Delete</span>
                            </a>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" sortable>
                </el-table-column>
            </el-table>
        </div>
        <div class="row justify-content-end">
            <label for="ResultsPerPageDropdown" class="results-per-page">Results Per Page:</label>
            <el-select id="ResultsPerPageDropdown" v-model="pagination.perPage" readonly="false" name="PageOptions" class="select-primary">
                <el-option v-for="(item, index) in pagination.perPageOptions" :value="item" class="select-primary" :key="index"></el-option>
            </el-select>

            <base-pagination :per-page="pagination.perPage" v-model="pagination.currentPage" :total="total" />
        </div>

        <!-- Add Operation / Theater Modal -->
        <b-modal ref="showOperationTheaterModal" scrollable hide-footer hide-header no-close-on-backdrop size="md" body-class="custom_alert_body">
           <center>
         <Header style="padding: 0px;" :pageTitle="modalHeaderText" class="card-container"></Header>
<hr/>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <label style="padding-top: 10px;">Name</label>
                        <base-input v-model="form.name" name="otName"></base-input>
                    </div>
                    <div class="col-md-12">
                        <label style="padding-top: 10px;">Abbreviation</label>
                        <base-input v-model="form.abbreviation" name="otAbbreviation"></base-input>
                    </div>
                    <div class="col-md-12">
                        <label style="padding-top: 10px;">Remark</label>
                        <base-input v-model="form.remark" name="otRemark"></base-input>
                    </div>
                </div>
            </div>
<hr/>

            <div class="alert_footer align-center">
                <base-button type="primary" @click="clickCloseModal()" class="btn-primary ">
                    <i class="tim-icons icon-double-left center-btn-content"></i>
                    Return to Table
                </base-button>

                <base-button type="primary" @click="addOperationTheater()" class="btn-info ">
                    <i class="tim-icons icon-bank center-btn-content"></i>
                    {{ modalButtonText }}
                </base-button>
            </div>
            </center>
        </b-modal>
    </card>
</center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Util from "@/util/util";
import Header from "@/components/App/Header";
import { Table, TableColumn, Select, Option, Button } from "element-ui";
import { BaseButton, Modal, BasePagination, ExportGroup } from "@/components";
import swal from "sweetalert2";

export default {
    name: "admin-operationtheatre",
    components: {
        Header,
        Modal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BaseButton,
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        ExportGroup,
    },
    data() {
        return {
            searchText: "",
            filteredTheaters: [],
            map: {
                "Id": "theaterId",
                "Abbreviation":	"abbreviation", 
                "Name":	"name",
                "Remark": "remark",
                "CreateDate": "createDateLabel",
                "UpdateDate": "updateDateLabel",
            },
            tableColumns: [
                {
                    prop: "name",
                    label: "Name",
                    minWidth: 210,
                    scope: "col"
                },
                {
                    prop: "abbreviation",
                    label: "Abbreviation",
                    minWidth: 210,
                    scope: "col"
                },
                {
                    prop: "remark",
                    label: "Remark",
                    minWidth: 210,
                    scope: "col"
                },
                {
                    prop: "createDateLabel",
                    label: "Created Date",
                    minWidth: 210,
                    scope: "col"
                },
                {
                    prop: "updateDateLabel",
                    label: "Modified Date",
                    minWidth: 210,
                    scope: "col"
                },
            ],
            form: {
                theaterId: 0,
                name: "",
                abbreviation: "",
                remark: "",
                createDate: "",
                updateDate: "",
            },
            countrySelection: null,
            addCountrySelection: "",
            pagination: {},
            searchQuery: "",
            searchedData: [],
            fuseSearch: null,
        };
    },
    async created() {
        this.$loaderApp.addRequest();
        await this.getTheaters();
        this.pagination = Util.getInitialPaginationInfo();
        this.$loaderApp.completeRequest();
    },
    updated() {
        let searchableFields = ["name", "abbreviation", "remark", "createDateLabel", "updateDateLabel"];
        this.fuseSearch = Util.setFuseSearch(this.allTableData(), searchableFields);
    },
    watch: {
        searchQuery(value) {
            this.searchedData = Util.fuseSearch(
                this.allTheaters,
                this.fuseSearch,
                value
            );
        },
    },
    computed: {
        ...mapGetters({
            allTheaters: "operationTheater/allTheaters",
            paginatedOperationTheaters: "operationTheater/paginatedOperationTheaters",
        }),
        queriedData() {
            return Util.searchedData(this.allTheaters, this.searchedData, this.from, this.to);
        },
        to() {
            return Util.toPaginationPage(this.pagination, this.total);
        },
        from() {
            return Util.fromPaginationPage(this.pagination);
        },
        total() {
            return Util.numberOfPaginationPages(this.searchedData, this.allTableData());
        },
        modalHeaderText() {
            return this.form.theaterId ? "Edit Operation / Theater" : "Add Operation / Theater";
        },
        modalButtonText() {
            return this.form.theaterId ? "Update Operation / Theater" : "Add New Operation / Theater";
        },
    },
    methods: {
        ...mapActions({
            getTheaters: "operationTheater/getTheaters",
            deleteTheater: "operationTheater/deleteTheater",
            saveTheater: "operationTheater/saveTheater",
        }),
        allTableData() {
            return this.allTheaters;
        },
        async addOperationTheater() {
            this.form.updateDate = new Date().toISOString();
            if (this.form.theaterId === 0) {
                this.form.createDate = new Date().toISOString();
            }
            await this.saveTheater(this.form).then((res) => {
                this.getTheaters();
                this.clickCloseModal();
                this.form = {
                    theaterId: 0,
                    name: "",
                    abbreviation: "",
                    remark: "",
                    createDate: "",
                    updateDate: "",
                };
            });
        },
        editOperationTheater(row) {
            this.form.theaterId = row.theaterId;
            this.form.name = row.name;
            this.form.abbreviation = row.abbreviation;
            this.form.remark = row.remark;
            this.form.createDate = row.createDate;
            this.form.updateDate = row.updateDate;
            this.$refs.showOperationTheaterModal.show();
        },
        openModal() {
            this.$refs.showOperationTheaterModal.show();
        },

        clickCloseModal() {
            this.form = {
                theaterId: 0,
                name: "",
                abbreviation: "",
                remark: "",
                createDate: "",
                updateDate: "",
            };
            this.$refs.showOperationTheaterModal.hide();
        },
        getExportData() {
            let data = this.searchedData.length > 0 ? this.searchedData : 
                this.allTableData();
            
            return Util.mapTheData(data, this.map);
        },

        handleDelete(row) {
            new swal({
                title: "Are you sure?",
                text: `Delete Theater?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#10b45a",
                cancelButtonColor: "red",
                confirmButtonText: "Yes, delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.deleteTheater(row.id);
                    this.searchText = "";
                }
            });
        },
    },
};
</script>

<style scoped>
.mt-40 {
    margin-top: 40px;
}



.roles {
    width: 95%;
    margin: 2%;
}

.btn-secondary:focus {
    outline-color: transparent;
}

.btn-secondary-dark:focus {
    outline-color: transparent;
}

.btn-secondary {
    background-color: #d3d7e9;
    border: none;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.btn-secondary:hover {
    background-color: #cccccc;
    color: #1d253b;
    border-color: #cccccc;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.btn-secondary-dark {
    background-color: #cccccc;
}

.btn-secondary-dark:hover {
    background-color: #d3d7e9;
    border: none;
    color: #1d253b;
}

.el-button.editing {
    color: #fff;
    border-color: red;
    background-color: red;
}

.center-btn-content {
 height:18px; margin-right: 3px
}
</style>
